module.exports = __webpack_public_path__ + "static/media/seller-lab-logo.116408b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/seller-lab-logo.svg
// module id = 265
// module chunks = 2